import type { UpcomingPriceChange } from '../api/types'

export function localTodayIso(now: Date = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
}

function atMidnight(iso: string): number {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d).getTime()
}

/** Whole days from today until `iso` (negative when past). */
export function daysUntil(iso: string, today: string = localTodayIso()): number {
  return Math.round((atMidnight(iso) - atMidnight(today)) / 86_400_000)
}

export function formatIsoDate(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}

/** Changes taking effect within 30 / 60 / 90 days, plus ones past their date. */
export function kpiCounts(changes: UpcomingPriceChange[], today: string = localTodayIso()) {
  const out = { d30: 0, d60: 0, d90: 0, overdue: 0 }
  for (const c of changes) {
    if (c.overdue) {
      out.overdue += 1
      continue
    }
    const d = daysUntil(c.effective_date, today)
    if (d <= 30) out.d30 += 1
    if (d <= 60) out.d60 += 1
    if (d <= 90) out.d90 += 1
  }
  return out
}
